import React from "react";
import { useSnackbarMessage } from "../../../Snackbar";
import InlineNoteEditor from "./InlineNoteEditor";

export default function ReceptionNote({
  entry,
  selectedVersions,
  fetchTimeline,
  canEdit,
  clientId,
}) {
  const displaySnackbarMessage = useSnackbarMessage();

  const versions = entry.versions || [];
  const selId =
    selectedVersions[entry.id] ||
    (versions.find((v) => v.is_latest)?.version_id ??
      versions[versions.length - 1]?.version_id);
  const selectedNoteVersion =
    versions.find((v) => v.version_id === selId) ||
    versions[versions.length - 1] ||
    null;

  const entryForEditor = selectedNoteVersion
    ? {
        ...entry,
        note: selectedNoteVersion.note_content,
        doctor_required: selectedNoteVersion.doctor_required,
        service_id: selectedNoteVersion.service_id,
        reservation_count: selectedNoteVersion.reservation_count,
        reservation_unit: selectedNoteVersion.reservation_unit,
      }
    : entry;

  return (
    <InlineNoteEditor
      clientId={clientId}
      entry={entryForEditor}
      selectedNoteVersion={
        selectedNoteVersion || {
          note_content: entry.note,
        }
      }
      canEdit={canEdit && (selectedNoteVersion?.is_editable ?? true)}
      showEditButton={!!(selectedNoteVersion?.is_latest ?? true)}
      onSave={async () => {
        fetchTimeline();
        displaySnackbarMessage({
          title: "Editace poznámky proběhla úspěšně.",
          content: "",
        });
      }}
    />
  );
}
